import { initialValidations }        from "_common/ssrWrapper";
import DonatePage                    from "_components/pages/donatePage";
import { getDonationDetails }        from "_services/api/donate";
import { getUserDetailsForDonation } from "_services/api/user";

const Donate = props => {

	return (
		<DonatePage
			donationDetails = { props?.donationDetails }
			streamerDetails = { props?.userDetails }
		/>
	);
};

const getServerSideProps = async context => initialValidations ( context, async defaultProps => {

	try {
		let donationDetails = {};

		if ( context.query.moneyDonationId && context.query.moneyDonationKey ) {

			const response = await getDonationDetails.bind ( defaultProps ) (
				{
					moneyDonationId  : context.query.moneyDonationId,
					moneyDonationKey : context.query.moneyDonationKey
				}
			);

			donationDetails = response;
		}

		const userId = context.query.id || donationDetails.sportsFanId;

		if ( !userId )
			return {
				redirect: {
					destination : "/",
					permanent   : false
				}
			};

		const results = await Promise.allSettled ( [
			getUserDetailsForDonation.bind ( defaultProps ) ( userId )
		] );

		let userDetails = {};
		let forceLogout = false;

		results.forEach ( ( result, index ) => {
			if ( result.status === "fulfilled" ) {
				switch ( index ) {
					case 0:
						userDetails = result.value?.userDetails;
						break;

				}
			}

			if ( result.status === "rejected" && result.reason?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
				forceLogout = true;
		} );

		if ( forceLogout )
			return {
				redirect: {
					destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
					permanent   : false
				}
			};

		return {
			props: {
				...defaultProps,
				userDetails,
				donationDetails
			}
		};
	} catch ( error ) {

		if ( error?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
			return {
				redirect: {
					destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
					permanent   : false
				}
			};

		return {
			props: {

				...defaultProps,
				userDetails     : {},
				donationDetails : {}
			}
		};
	}

} );

export { getServerSideProps };

export default Donate;
